import { createErrorList } from 'Cloud/Application/ErrorList';

export const vigboAlbumErrors = createErrorList({
    name_too_long: 'Превышено количество символов в названии',
    required: 'Название не может быть пустым',
    unknown: 'Ошибка на сервере',
    create_error: 'Не удалось создать Галерею Vigbo',
    add_error: 'Не удалось добавить в Галерею Vigbo',
    'CONDITION/BADNAME':
        'Недопустимое название. В названии нельзя использовать символы «{INVALID_CHARACTERS}». Также название не может состоять только из точки «.» или из двух точек «..»',
});
